import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import Loading from "../Shared/Loading";


const PrivateRoute = ({ children }) => {
  const { pathname } = useLocation();
  const { isLoading, user : {email} } = useSelector(state => state.auth)

  if (isLoading) {
    return <Loading/>;
  }

  if (!isLoading && !email) {
    return <Navigate to='/login' state={{ path: pathname }} />;
  }

  return children;
};

export default PrivateRoute;
